import { Nullable } from "@/types/common";
import { ApiConstant } from "@/const";

/**
 * Get attachment from path
 *
 * @param {string | null | undefined} path
 * @returns {string}
 */
export const getAttachmentFromPath = (path?: Nullable<string>): string => {
  if (!path) return "";
  const baseUrl = ApiConstant.BASE_URL.endsWith("/") ? ApiConstant.BASE_URL.slice(0, -1) : ApiConstant.BASE_URL;
  const pathUrl = path.startsWith("/") ? path : `/${path}`;
  return baseUrl + pathUrl;
};
